import { render } from "./PublicShareAuthSidebar.vue?vue&type=template&id=5e2bc20a&scoped=true"
import script from "./PublicShareAuthSidebar.vue?vue&type=script&lang=js"
export * from "./PublicShareAuthSidebar.vue?vue&type=script&lang=js"

import "./PublicShareAuthSidebar.vue?vue&type=style&index=0&id=5e2bc20a&lang=css"
import "./PublicShareAuthSidebar.vue?vue&type=style&index=1&id=5e2bc20a&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2bc20a"]])

export default __exports__